import ApiClient from '../methods/api/apiClient'
import methodModel from '../methods/methods';
export const Logo =() =>async(dispatch)=>{
            //  I AM PUTTING THE LOGO STATICALLY WHEN THE CODE IS LIVE REMOEV THE STATIC LOGO  JUST REMOVE THEN IT WORK SMOOTHLY ON ALL 
            return dispatch({ type: 'Logo', data:{logo:'/assets/img/logo.png'} })
};